<script setup lang="ts">

import {defineProps} from "vue";
import PercentageText from '@/components/Interface/Text/PercentageText.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import ColoredNumber from '@/components/Elements/Generic/ColoredNumber.vue'

/**
 * Props
 */
defineProps({
  type: {
    type: String,
    required: true,
  },
  amount: {
    type: Number,
    default: 0,
    required: true,
  },
  percentage: {
    type: Boolean,
    default: false,
  }
});


</script>

<template>
  <div class="flex flex-row md:flex-col py-2 align-middle">
      <div>
        <GenericIcon :type="type"/>
      </div>
      <div class="text-subtext align-middle mt-0 md:mt-2 md:ps-0 ps-2 justify-center">
        <span v-if="percentage" class="">
          <PercentageText :value="amount"></PercentageText>
        </span>
        <span v-else>
          <ColoredNumber :amount="amount"/>
        </span>
      </div>
  </div>
</template>

<style scoped lang="scss">

</style>